import React, { useState, useEffect, useRef, useContext } from 'react'
import { IEnquiryDetail } from '../../../models/Enquiry'
import Conditional from '../../common/Conditional'
import '../Enquiries.css'
import EnquiryDetail from './EnquiryDetail'
import EnquiryContext from '../context/EnquiryContext'
import FormDependencyLoaderContext from '../../context/FormDependencyLoaderContext'

export interface IEnquiryMyAccountProps {
  clearErrors: () => void
  handleErrors?: (any) => void
}

const EnquiryMyAccount = (props: IEnquiryMyAccountProps) => {
  const mountedRef = useRef(false)
  const context = useContext(EnquiryContext)
  const formDependencyContext = useContext(FormDependencyLoaderContext)
  const [isLoading, setIsLoading] = useState(true)
  const [toggleState, ,] = useState(1)
  const [data, setData] = useState<IEnquiryDetail>()

  useEffect(() => {
    mountedRef.current = true
    formDependencyContext.show()
    if (mountedRef.current) {
      setData(context.enquiry)
      setIsLoading(false)
      formDependencyContext.hide()
    }
    return () => {
      mountedRef.current = false
    }
  }, [context.enquiry])

  const handleErrors = (error) => {
    props.handleErrors(error)
  }

  const address = []
  if (data?.businessABN != null) address.push(data?.businessABN)
  if (data?.businessName != null) address.push(data?.businessName)
  if (data?.businessAddressLine1 != null)
    address.push(data?.businessAddressLine1)
  if (data?.businessAddressLine2 != null)
    address.push(data?.businessAddressLine2)
  if (data?.businessSuburb != null) address.push(data?.businessSuburb)
  if (data?.businessState != null && data?.businessPostcode != null)
    address.push(data?.businessState + ' ' + data?.businessPostcode)
  if (data?.nomineePhone != null) address.push(data?.nomineePhone)

  return (
    <Conditional if={!isLoading && data}>
      <h2>Enquiry details</h2>
      <h3>Enquiry number: {data?.number}</h3>

      <div className="tabs js-tabs">
        <div className="tab-selections" role="tablist"></div>
        <div className="tab-content">
          <div className={toggleState === 1 ? 'tab-1 is-active' : 'tab-1'}>
            <EnquiryDetail data={data} handleErrors={handleErrors} />
          </div>
        </div>
      </div>
    </Conditional>
  )
}
export default EnquiryMyAccount
